export const TEMPLATES_LIST_HEIGHT = 2000
